
<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <div class="p-3 mb-2">
        <!-- <div class="col-12">
         
          <h5 style="text-align: left">Change Password
            <b-button class="float-right"  variant="danger" @click="handleBack">Back</b-button>
        </h5>
        
          
        <hr/>
        </div> -->
        <div class="col-12" style="margin-top:4px;">
        <h5> Change Password 
          <b-button class="float-right" variant="danger" @click="handleBack">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>Back</b-button
        >
        </h5>
        <hr/>
        
      </div>
        <div class="col-12">

          <table>
            <tr>
              <td>User Login :</td>
              <td><input class ="form-control" value="9987400342" autocomplete="off" disabled /></td>
            </tr>
            <tr>
              <td>Old Password:</td>
              <td>
                <input class ="form-control" type="password" />
              </td>
            </tr>
             <tr>
              <td>New Password:</td>
              <td>
                <input class ="form-control"  type="password" />
              </td>
            </tr>
             <tr>
              <td>Confirm Password:</td>
              <td>
                <input class ="form-control" type="password" />
              </td>
            </tr>
             </table>
            <!-- <input type="text" name="Mobile No" placeholder="9987400342" disabled>
        <input type="password" name="Old_Password" placeholder="Old_Password" required>
        <input type="password" name="New_password" placeholder="New_password" required>
        <input type="password" name="Confirm_password" placeholder="Confirm_password" required>
        <input type="submit" @click="handleSubmit3" value="Update">
        </tr> -->
         
        </div>
        <hr />
        <div class="btn-group col-12">
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="handleSubmit3"
        >
          Update</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="handleSubmit4"
        >
          Reset
        </button>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  methods: {
    handleSubmit2() {
      alert("update Success");
    },
    handleSubmit3() {
      alert("password change succesfully");
    },
    handleSubmit4() {
      alert("Reset all data");
    },
    handleBack() {
      this.$router.go(-1);
    },
    reset_details() {
      this.Observations = "";
    },
  },
};
</script>
<style scoped>
body {
  font-family: Arial, Helvetica, sans-serif;
}
</style>

